import { faKey, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@restart/ui/esm/Button";
import { AvForm, AvInput } from "availity-reactstrap-validation";
import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Label } from "reactstrap";
import { clearErrorAndSuccessful, loginUser } from "../redux/rootActions";
import { TranslationComponentProps } from "../types/translationComponentProps";

interface IProps extends TranslationComponentProps {
  closeLogin: () => void;
  openForgotPassword: () => void;
  openRegistration: () => void;
  openGuestModal: () => void;
  isGuestTokenValid: boolean;
}

const Login: React.FC<IProps> = (props: IProps) => {
  const dispatch = useDispatch();
  const { error, successfulLoginOrSignIn } = useSelector(
    (state: RootStateOrAny) => state.Auth,
  );

  useEffect(() => {
    dispatch(clearErrorAndSuccessful());
  }, []);

  useEffect(() => {
    if (successfulLoginOrSignIn) {
      props.closeLogin();
    }
  }, [successfulLoginOrSignIn]);

  const handleValidSubmit = (event, values) => {
    dispatch(loginUser(values.email, values.password));
  };

  const openForgotPass = () => {
    props.closeLogin();
    props.openForgotPassword();
  };

  const openRegistration = () => {
    props.closeLogin();
    props.openRegistration();
  };

  const openGuestModal = () => {
    props.closeLogin();
    props.openGuestModal();
  };

  return (
    <div className="login">
      <AvForm onValidSubmit={handleValidSubmit}>
        <div className="d-flex justify-content-center pt-2 pl-3 w-100 login-header">
          <Label>{props.t("LOGIN.title")}</Label>
        </div>

        <div className="d-inline-flex w-100 align-items-center login-row">
          <Button className="login-input-btn" disabled>
            <FontAwesomeIcon icon={faUserAlt} />
          </Button>
          <AvInput
            className="login-input"
            name="email"
            placeholder={props.t("LOGIN.email")}
            type="email"
          />
        </div>
        <div className="d-inline-flex w-100 align-items-center login-row">
          <Button className="login-input-btn" disabled>
            <FontAwesomeIcon icon={faKey} />
          </Button>
          <AvInput
            className="login-input"
            name="password"
            placeholder={props.t("LOGIN.password")}
            type="password"
          />
        </div>
        {error && (
          <div className="d-flex justify-content-center pt-1 pb-2">
            <span className="text-danger">{props.t("LOGIN.error")}</span>
          </div>
        )}
        <div className="d-inline-flex w-100 justify-content-center align-items-center login-submit mt-2">
          <Button
            className="login-button cancel-button"
            onClick={props.closeLogin}
          >
            {props.t("LOGIN.cancel")}
          </Button>
          <Button className="login-button" type="submit">
            {props.t("LOGIN.login")}
          </Button>
        </div>
        <div className="d-flex justify-content-center pt-1">
          <span
            className="text-secondary login_forgot_pass"
            style={{ cursor: "pointer" }}
            onClick={() => openForgotPass()}
          >
            {props.t("LOGIN.forgot_pass")}
          </span>
        </div>
        <div className="d-inline-flex w-100 justify-content-center pt-3 pb-2">
          <Button
            className="login-button login_registration-button"
            onClick={() => openRegistration()}
          >
            {props.t("REGISTRATION.signin")}
          </Button>
        </div>
        <div className="d-inline-flex w-100 justify-content-center pb-2">
          <Button
            className="login-button login_registration-button"
            disabled={props.isGuestTokenValid}
            onClick={() => openGuestModal()}
          >
            {props.t("REGISTRATION.guest")}
          </Button>
        </div>
      </AvForm>
    </div>
  );
};

export default withTranslation()(Login);
